import { render, staticRenderFns } from "./ReportBoxTopProducts.vue?vue&type=template&id=29dc0f48&scoped=true&"
import script from "./ReportBoxTopProducts.vue?vue&type=script&lang=js&"
export * from "./ReportBoxTopProducts.vue?vue&type=script&lang=js&"
import style0 from "./ReportBoxTopProducts.vue?vue&type=style&index=0&id=29dc0f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc0f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29dc0f48')) {
      api.createRecord('29dc0f48', component.options)
    } else {
      api.reload('29dc0f48', component.options)
    }
    module.hot.accept("./ReportBoxTopProducts.vue?vue&type=template&id=29dc0f48&scoped=true&", function () {
      api.rerender('29dc0f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportBoxTopProducts.vue"
export default component.exports